/**
 * 根据分类id，获取上层分类id
 * @param id Number
 * @param level Number
 * @param data Array 分类树
 * @returns categoryId
 */

export function getCategoryIdBylevel(id, level, data, options = {}) {
    const { idKey = 'categoryId', pidKey = 'parentId' } = options;
    let cateId = id;
    let retId = null;
    const map = data.reduce((result, item) => {
        result[+item[idKey]] = item;
        return result;
    }, {});
    while (!retId) {
        const target = map[cateId];
        if (!target) break;
        if (target.level === level) {
            retId = +target[idKey];
        } else {
            cateId = +target[pidKey];
        }
    }
    return retId;
}

export function getCategoryInfoById(id, data, options = {}) {
    const { idKey = 'id' } = options;
    return data.find((item) => item[idKey] === id);
}

export default {};
